import { XIcon } from '@phosphor-icons/react'
import * as styles from './active-filters-tag.css.ts'

type ActiveFiltersTagProps = {
  onReset: () => unknown
}

export const ActiveFiltersTag: React.FC<ActiveFiltersTagProps> = ({ onReset }) => (
  <span className={styles.tag}>
    Edited
    <button className={styles.resetButton} onClick={onReset} aria-label="Reset filters">
      <XIcon size={12} weight="light" />
    </button>
  </span>
)
